export default {
  data () {
    return {
      entity: {}
    }
  },
  methods: {
    item: function () {
      return {
        broadleafName: '株式会社ブロードリーフ',
        broadleafCode: '0000000000000000',
        honshaName: '本社',
        honshaCode: '0000000000000000',
        enterpriseCode: '企業コード',
        enterpriseName: '企業名',
        enterpriseAuthCode: '企業認証コード',
        enterpriseAuthPass: '企業認証パスワード',
        domain: 'ドメイン',
        licenseStartDate: 'ライセンス開始日',
        licenseEndDate: 'ライセンス終了日',
        licenseType: 'ライセンス種別',
        inventoryWayDiv: '手入力棚卸許可区分',
        simpleAuthCertificationDiv: '簡易認証許可区分',
        inventoryDeleteDiv: '棚卸情報削除許可区分',
        inventoryDownloadDiv: '棚卸結果DL可否区分',
        inventoryCancelDiv: '棚卸完了解除許可区分',
        accountbookDiv: '帳簿未使用区分',
        // inventoryDownloadDiv: '棚卸結果DL可否',
        stockFileOperationDiv: '棚卸対象ファイル操作許可区分',
        inventoryCompletionDiv: '棚卸完了許可区分',
        readerSetDiv: 'リーダー設定可否区分',
        enterpriseCreateDate: '企業情報作成日',
        sectionName: '拠点名',
        sectionCode: '拠点コード',
        ownSectionName: '自社拠点名称',
        ownSectionCode: '自社拠点コード',
        userId: 'ユーザID',
        userName: 'ユーザ名',
        userPassword: 'パスワード',
        userDiv: 'ユーザ権限',
        simpleUserCode: '簡易ID',
        simplePassword: '簡易パスワード',
        zenhankaku: '全半角',
        hankakusuuji: '半角数字',
        hankakueisuuji: '半角英数字',
        electricWaveStrength: '電波強度',
        electricWaveTime: '電波照射時間',
        session: 'セッション',
        goodsSpecificCode: '商品特定コード',
        goodsCode: '商品コード',
        goodsName: '商品名称',
        stockName: '在庫名称',
        printName: '印字名称',
        goodsCreateDate: '商品情報作成日',
        fromDate: '開始日',
        toDate: '終了日',
        installmentTime: '割賦回数',
        businessType: '業態区分',
        inventoryIdentyName: '棚卸識別名',
        publicant: '変換コード発行要求',
        save: '保存',
        delete: '削除',
        approval: '承認',
        release: '解除',
        download: 'ダウンロード',
        upload: 'アップロード',
        uploadDateFrom: 'アップロード開始日',
        uploadDateTo: 'アップロード終了日',
        uploadUserName: 'アップロードユーザ',
        uploadStatus: 'アップロード状態',
        DateFrom: '開始日',
        DateTo: '終了日',
        search: '検索',
        dsShopCode: 'キャリア店舗コード',
        dsShopName: 'キャリア店舗名称',
        enterpriseCreateDateFrom: '企業情報作成日',
        enterpriseCreateDateTo: '企業情報作成日',
        inventoryName: '棚卸識別名',
        inventoryStatus: '棚卸状態',
        janCode: 'JANコード',
        quantity: '数量',
        individualCode: '個体識別コード',
        generalItem: '汎用項目'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/item.js